// extracted by mini-css-extract-plugin
module.exports = {"disclaimer":"_13RLU5kuJ7Zp1cZmcxdyqT"};